import services from "../../services";
import Vue from "vue";

const strict = true;
const defaultComponentId = "defaultComponentId";

const state = {
  provinces: {}
};

const getters = {
  provinces: state => componentId => {
    if (componentId) {
      return state.provinces[componentId];
    }
    return state.provinces[defaultComponentId];
  }
};

const mutations = {
  reset(state) {
    state.provinces = {};
  },
  loadingProvinces(state, componentId) {
    if (componentId === undefined) {
      componentId = defaultComponentId;
    }
    Vue.set(state.provinces, componentId, []);
  },
  provincesLoaded(state, { provinces, componentId }) {
    if (componentId === undefined) {
      componentId = defaultComponentId;
    }
    Vue.set(state.provinces, componentId, provinces);
  },
  errorLoadingProvinces(state) {
    Vue.set(state.provinces, null, []);
  }
};

const actions = {
  async getProvinces({ commit }, { region, componentId }) {
    if (componentId === undefined) {
      componentId = defaultComponentId;
    }
    try {
      commit("loadingProvinces", componentId);
      let provinces = await services.addressService.getProvince(
        commit,
        region.regionId,
        componentId
      );
      commit("provincesLoaded", { provinces, componentId });
    } catch (error) {
      commit("error/setError", error, { root: true });
    }
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
